module.exports = __webpack_public_path__ + "static/media/ne.5c109026.svg";